/**
 * SP時ブロックスウォッチカルーセル — スクロール位置保持
 *
 * バリアント選択時にProductRerenderがvariant-pickerブロックをreplaceWithで
 * 入れ替えるため、スクロール位置がリセットされる問題を解決する。
 *
 * フロー:
 *   1. product:rerender (capture) → replaceWith前にscrollLeftを保存
 *   2. variant:change → replaceWith後にscrollLeftを復元
 */
(function() {
  'use strict';
  if (!window.matchMedia('(max-width: 699px)').matches) return;

  document.querySelectorAll('product-rerender[observe-form]').forEach(function(rerenderEl) {
    var formId = rerenderEl.getAttribute('observe-form');
    var form = document.forms[formId];
    if (!form || !rerenderEl.querySelector('.variant-picker__option-values')) return;

    var savedPositions = [];

    form.addEventListener('product:rerender', function() {
      savedPositions = [];
      rerenderEl.querySelectorAll('.variant-picker__option-values').forEach(function(el) {
        savedPositions.push(el.scrollLeft);
      });
    }, { capture: true });

    form.addEventListener('variant:change', function() {
      if (!savedPositions.length) return;
      var pos = savedPositions;
      savedPositions = [];
      requestAnimationFrame(function() {
        var els = rerenderEl.querySelectorAll('.variant-picker__option-values');
        for (var i = 0; i < els.length && i < pos.length; i++) {
          if (pos[i] > 0) els[i].scrollLeft = pos[i];
        }
      });
    });
  });
})();
